import {Lieferkunde} from "./lieferkunde";

export class LieferkundeGroup {
  a3KundeNr: number;
  label: string;
  lieferkunden: Lieferkunde[] = [];
}
